import React from 'react';
import { Search } from 'lucide-react';

export default function SearchInput({ value, onChange, placeholder = 'Global node search...', className = '' }) {
  return (
    <label className={`cc-input-shell flex h-10 w-full max-w-[420px] items-center gap-2 rounded-xl px-3 text-sm ${className}`}>
      <Search className="h-4 w-4" />
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="cc-input-field h-full w-full bg-transparent text-sm outline-none"
      />
    </label>
  );
}
